export enum GroupAppStatus {
  DRAFT = 'DRAFT',
  EXECUTING = 'EXECUTING',
  SUBMITTED = 'SUBMITTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
